// First-login terms/risk acceptance record (client-side, Phase A).
// Phase B moves the source of truth to usercenter (terms_accepted_at +
// version on t_user) — the localStorage record then becomes a cache.
// Bumping TERMS_VERSION re-prompts every account on next sign-in.
// v2 (2026-08-07): SakerX-authored Terms of Use 1.0 + Risk Disclosure 1.0
// replace the inherited third-party terms PDF.
// v3 (2026-08-07): SakerX Privacy Policy 1.0 replaces the inherited
// third-party privacy PDF; Terms 1.1 completes the cross-reference.
export const TERMS_VERSION = 'v3';

const key = (uid: string) => `saker-terms-${TERMS_VERSION}:${uid}`;

// Storage failures fail-open (treated as accepted): a broken/blocked
// localStorage must never lock a user out of a session they already proved
// with a signature — the SIWE statement itself carries the acceptance line.
export const hasAcceptedTerms = (uid: string): boolean => {
  try {
    return !!localStorage.getItem(key(uid));
  } catch {
    return true;
  }
};

export const recordTermsAccepted = (uid: string): void => {
  try {
    localStorage.setItem(key(uid), new Date().toISOString());
  } catch {
    // fail-open by design, see above
  }
};
